import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useConfig } from '../../hooks/useConfig';

const Navbar = () => {
    const { isAuthenticated, logout, user } = useAuth();
    const { config } = useConfig();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        // After logout, navigate to the public home page.
        navigate('/');
    };

    const getLoginUrl = () => {
        if (!config?.auth_redirect_url) {
            return "/login"; // Fallback to internal login page
        }
        const redirectParam = `?redirect=${window.location.origin}${window.location.pathname}`;
        return `${config.auth_redirect_url}${redirectParam}`;
    };

    return (
        <nav style={{ background: '#1F2937', padding: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'white' }}>
            <div>
                <NavLink to="/" style={{ color: 'white', textDecoration: 'none', fontWeight: 'bold', fontSize: '1.2rem' }}>
                    ichrahly meet
                </NavLink>
                {isAuthenticated && user?.role === 'super_admin' && (
                     <NavLink to="/admin" style={{ color: 'white', textDecoration: 'none', marginLeft: '1.5rem' }}>
                        Admin Dashboard
                    </NavLink>
                )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
                <a href="https://ichrahly.com" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'none' }}>
                    Visit ichrahly.com
                </a>
                
                {isAuthenticated && user ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontWeight: 'bold' }}>{user?.first_name} {user?.last_name}</div>
                            {/* --- FIX: Changed 'Administrator' to 'Super Admin' for clarity --- */}
                            <div style={{ fontSize: '0.8rem', color: '#9CA3AF' }}>{user?.role === 'super_admin' ? 'Super Admin' : 'User'}</div>
                        </div>
                        <button onClick={handleLogout} style={{ background: '#4B5563', border: 'none', color: 'white', padding: '0.5rem 1rem', borderRadius: '5px', cursor: 'pointer' }}>
                            Logout
                        </button>
                    </div>
                ) : (
                    <a href={getLoginUrl()} style={{ color: 'white', textDecoration: 'none', background: '#2563EB', padding: '0.5rem 1rem', borderRadius: '5px' }}>
                        Login
                    </a>
                )}
            </div>
        </nav>
    );
};

export default Navbar;
